import { render } from "./ViDienTu.vue?vue&type=template&id=2f672a59&scoped=true"
import script from "./ViDienTu.vue?vue&type=script&lang=js"
export * from "./ViDienTu.vue?vue&type=script&lang=js"

import "./ViDienTu.vue?vue&type=style&index=0&id=2f672a59&lang=scss&scoped=true"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f672a59"]])

export default __exports__